






























import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Browse extends Vue {
    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getMyLibraries(this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 布尔值格式化：cellValue为后台返回的值
    formatBoolean(row: any, column: any, cellValue: boolean) {
        let ret = ''  //你想在页面展示的值
        if (cellValue) {
            ret = "是"  //根据自己的需求设定
        } else {
            ret = "否"
        }
        return ret;
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    onTest(row: any) {
        this.$store.state.topic = row;
        sessionStorage.removeItem("topics");
        this.$router.push({ path: "/test/practice", query: { libraryId: row.id } });
    }

    onMock(row: any) {
        this.$store.state.topic = row;
        sessionStorage.removeItem("topics");
        this.$router.push({ path: "/test/mock", query: { libraryId: row.id } });
    }

    onChapter(id: string) {
        this.$router.push({ path: "/test/chapter", query: { libraryId: id } });
    }

    onTopic(id: string) {
        this.$router.push({ path: "/test/browse", query: { libraryId: id } });
    }

    onExport(row: any) {
        this.$apis.getLibraryXML(row.id)
            .then((res: any) => {
                const blob = new Blob([res], { type: 'text/xml' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = row.name+".xml";
                a.click();
                window.URL.revokeObjectURL(url);
            });
    }
}
